<template lang="pug">
  el-dialog(:visible.sync="visible" :title="title" @close="closeModal")
    div(v-for="(municipio, index) in municipios" :key="index")
      el-collapse(:value="municipio.expanded")
        el-collapse-item(:title="`${municipio.nome} - (${municipio.propostas.length})`" class="custom-collapse-item" )
          table.table
            thead
              tr
                th CAR
                th Data
                th Hora
                th Ações
            tbody
              tr(v-for="(proposta, i) in municipio.propostas" :key="i")
                td(style="display: flex; align-items: left;")
                    span(v-tooltip='{ label: "Copiar", position: "bottom", minWidth: "30px" }')
                        button-component.copy-button(
                                        label='',
                                        icon='mdi-content-copy',
                                        color='green',
                                        @click.native='copyClipboard(proposta)'
                                )
                    | {{ proposta.car }}
                td {{ proposta.data }}
                td {{ proposta.hora }}
                td
                  el-button(
                  @click="detalharImovel(proposta)"
                  size="small"
                  ) Detalhes

    span.slot-footer(style="display: flex; justify-content: space-between; align-items: center;")
      el-button(@click="manterAlerta" class="btn-manter")
        i(class="el-icon-close")|  Manter Alerta
      el-button(@click="limparAlerta" class="btn-limpar")
        i(class="el-icon-check")|  Limpar Alerta

</template>

<script>
import { atualizarParaLido } from '@/services/processo.service';
import { buscarUrlAcessoFichaImovel } from '@/services/ficha-imovel.service';

export default {
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    tipoAlerta: { type: Number, required: true },
    municipios: { type: Array, required: true },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    manterAlerta() {

      this.$emit("close");
    },
    detalharImovel(proposta) {
        buscarUrlAcessoFichaImovel(proposta.id_processo).then((response) => {
                        window.open(response, '_blank');
                    });

    },
    limparAlerta() {
      atualizarParaLido(this.tipoAlerta)
        .then(() => {
          this.$toast({
            showClose: true,
            message: 'Informações salvas com sucesso!',
            type: 'success'
          });
          this.$emit("close");
          this.$emit("updateAlert", "Alerta Limpo!");

        })
        .catch((error) => {
          this.$toast({
            showClose: true,
            message: 'Erro ao atualizar os alertas para lido!',
            type: 'error',
          })
        });
    },
    copyClipboard(item) {
            navigator.clipboard.writeText(item.car);
            this.$toast({
                showClose: true,
                message: 'Código Copiado',
                type: 'success'
            });
        },
  },
};
</script>

<style scoped>
.accordion-trigger {
  font-weight: bold;
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ddd;
}

.el-dialog {
  max-height: 90vh;
  border-radius: 10px;
  overflow: hidden;
}

.el-dialog__header {
  border-bottom: 1px solid #ccc;
  padding: 15px;
  font-weight: bold;
  background-color: #f7f7f7;
}

::v-deep(.el-overlay) {
  overflow: visible !important;
}

::v-deep(.custom-collapse-item .el-collapse-item__header) {
  color: #000;
  font-weight: bold;
  padding-left: 20px;
  background-color: #dadbdb !important;
  ;
  font-size: 14px;
}

.custom-collapse-item .el-collapse-item__header {
  color: #fff;
  font-weight: bold;
  background-color: #333 !important;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.2;
  display: flex;
  align-items: center;
  cursor: pointer;
}

::v-deep(.custom-collapse-item .el-collapse-item__header) {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
}

::v-deep(.custom-collapse-item .el-collapse-item__arrow) {
  order: -1;
  margin-left: 0px;
  margin-right: 10px;
}

.custom-collapse-item .el-collapse-item__header:hover {
  background-color: #444;
}


::v-deep(.el-dialog__wrapper) {
  position: absolute;
  top: 50px;
}

::v-deep(.el-dialog) {
  max-height: none;
  overflow: visible;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.table thead th {
  padding: 8px;
  border-bottom: 2px solid #848282;
  text-align: left;
}

.table tbody tr {
  border-bottom: 1px solid #ccc;
}

.table tbody tr:hover {
  background-color: #f2f2f2;
}

.table tbody td {
  padding: 8px;
}

.slot-footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #ccc;
}


.slot-footer .btn-manter {
  background-color: #d9d9d9;
  color: #000;
  border: none;
}

.slot-footer .btn-limpar {
  background-color: #4CAF50;
  color: #fff;
  border: none;
}

.copy-button {
    background-color: transparent !important;
    box-shadow: none !important;
}
</style>
